import { ColorScaleConfig } from '@/utils/colorScale'
import { ChartComponent } from '..'
import { Limits } from './limits'
import { Pattern } from './bars'

export type CircleHighlight = {
  labels: string[]
  colors: string[]
  patterns?: Pattern[]
  positions: [number, number][]
  values?: [number | string, number][]
  offsets?: [number, number][]
  radius?: number
  colorScale?: ColorScaleConfig
  visible?: boolean
}

export const createCircleHightlight = (
  {
    colors,
    labels,
    offsets,
    positions,
    patterns,
    colorScale,
    visible,
    radius,
    values
  }: CircleHighlight,
  limits: Limits
): ChartComponent<'highlight-circle'>[] => [
  {
    type: 'highlight-circle',
    xLimits: limits.x,
    yLimits: limits.y,
    labels,
    colors,
    colorScale,
    patterns,
    visible,
    radius: radius ?? 4,
    positions,
    values: values ?? positions,
    offsets
  }
]

export const createCircleHightlights = (
  circles: CircleHighlight[],
  limits: Limits
): ChartComponent[] => {
  return [...circles.flatMap((circle) => createCircleHightlight(circle, limits))]
}
